<template>
  <select v-model="time">
    <option v-if="!timeIsInChoice" :value="time">{{timeFormatted(time)}}</option>
    <option v-for="i in nbElements" :value="indexToTime(i)">{{indexToTimeFormatted(i)}}</option>
  </select>
</template>

<script>

export default {
  name: "TimePickerAsSelect",
  props: {
    value: {
      type: String,
      required: true
    },
    momentFormat: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss',
      validator: val => val.includes('HH:mm')
    },
    timeStep: {
      Type: Number,
      required: false,
      default: 15,
      validator: val => 60 % val === 0
    },
    timeFormat: {
      type: String,
      default: 'hh:mm A',
      validator: val => ['HH:mm', 'hh:mm A'].includes(val)
    }
  },

  data() {
    return {
      time: null
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.time = newValue.substring(this.timePosition, this.timePosition+5);
      }
    },
    time(newTime) {
      let newValue = this.value.substring(0, this.timePosition) + newTime + this.value.substring(this.timePosition+5);
      this.$emit('input', newValue);
    }
  },

  computed: {
    timePosition() {
      return this.momentFormat.indexOf('HH:mm');
    },
    nbElements() {
      return Math.floor(24 * 60 / this.timeStep);
    },
    timeIsInChoice() {
      if (!this.time) { return false; }
      let minute = parseInt(this.time.substring(3,5));
      return minute % this.timeStep === 0;
    }
  },

  methods: {
    indexToTimeFormatted(i) {
      return this.indexToTime(i, true)
    },
    indexToTime(i, formatted = false) {
      let hour   = Math.floor((i-1) * this.timeStep / 60);
      let minute = (i-1) * this.timeStep % 60;
      let time = `${hour.toString().padStart(2,'0')}:${minute.toString().padStart(2,'0')}`;
      return formatted ? this.timeFormatted(time) : time;
    },
    timeFormatted(time) {
      if (this.timeFormat === 'hh:mm A') {
        let isAM = parseInt(time.substring(0,2)) < 12
        time = time.replace('00:', '12:') + ' ' + (isAM ? ' AM' : ' PM');
      }
      return time;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>